export const PLATFORM_SETUP_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
} as const

export type PlatformSettingNameType =
  | 'TITLE'
  | 'COMPANY_NAME'
  | 'LOGO'
  | 'LOGO_SMALL'
  | 'FAVICON'
  | 'COLOR_PRIMARY'
  | 'COLOR_SECONDARY'
  | 'CUSTOM_STYLE'
  | 'EMAIL_LOGIN_ENABLED'
  | 'SAML_LOGIN_ENABLED'
  | 'SAML_IDP_SSO_URL'
  | 'SAML_CERTIFICATE'
  | 'LOGO_SSO'
  | 'SUPPORT_EMAIL'
  | 'SUPPORT_PHONE'
  | 'EXTERNAL_RESOURCES_URL'
  | 'LEGAL_RT_ORGANISME_NAME'
  | 'LEGAL_RT_CONTACT_ADDRESS'
  | 'LEGAL_RT_DPO_EMAIL'
  | 'PLATFORM_SETUP_STATUS'
  | 'ENABLE_TRANSACTIONAL_EMAILS'

export type PlatformSettingsValuesType = Record<PlatformSettingNameType, string>

export const SETUP_STEPS = ['identity', 'branding', 'login', 'contact', 'team', 'recap'] as const
export type SetupStepType = (typeof SETUP_STEPS)[number]

// Champs enregistrés par chaque étape (l'étape connexion calcule les siens ; l'étape équipe
// agit tout de suite, invitation par invitation, et n'enregistre aucun réglage).
// Sections enregistrables : les étapes de l'assistant, plus celles propres à « Ma plateforme ».
// L'étape Contact de l'assistant regroupe support, ressources et responsable de traitement ;
// « Ma plateforme » les enregistre séparément, pour qu'un panneau ne réécrive pas les
// champs des autres avec les valeurs lues à son ouverture.
export type SaveSectionType = SetupStepType | 'emails' | 'support' | 'resources' | 'legal'

const SUPPORT_FIELDS: PlatformSettingNameType[] = ['SUPPORT_EMAIL', 'SUPPORT_PHONE']
const RESOURCES_FIELDS: PlatformSettingNameType[] = ['EXTERNAL_RESOURCES_URL']
const LEGAL_FIELDS: PlatformSettingNameType[] = [
  'LEGAL_RT_ORGANISME_NAME',
  'LEGAL_RT_CONTACT_ADDRESS',
  'LEGAL_RT_DPO_EMAIL',
]

export const STEP_FIELDS: Record<Exclude<SaveSectionType, 'login' | 'team' | 'recap'>, PlatformSettingNameType[]> = {
  identity: ['COMPANY_NAME', 'TITLE'],
  // Un seul logo saisi (LOGO_SMALL) : il est recopié dans LOGO et FAVICON à l'enregistrement.
  branding: ['LOGO_SMALL', 'COLOR_PRIMARY', 'COLOR_SECONDARY', 'CUSTOM_STYLE'],
  contact: [...SUPPORT_FIELDS, ...RESOURCES_FIELDS, ...LEGAL_FIELDS],
  support: SUPPORT_FIELDS,
  resources: RESOURCES_FIELDS,
  legal: LEGAL_FIELDS,
  emails: ['ENABLE_TRANSACTIONAL_EMAILS'],
}

// « Plus tard » : ne plus rouvrir l'assistant automatiquement pendant la session.
export const SETUP_DISMISSED_SESSION_KEY = 'platformSetupDismissed'
